import React, { useEffect, useState } from 'react';
import classes from "../routes/HomePage.module.css";
import { useNavigate } from 'react-router-dom';
import {  FaCopyright} from 'react-icons/fa6';
import { getImagesApi } from '../http/http';
import Loader from './Player/UI/Loader/Loader';
import Drawer from './Drawer';

const CategoriesSection = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
    
      const [loader, setLoader] = useState(true);
      const [drawer, setDrawer] = useState(false);
  
      const fetchImages = async () => {
          try {
              setLoader(true);
              const response = await getImagesApi();
              console.log(response, 'resposne....');
              setData(response?.data);
              setLoader(false);
  
          } catch (error) {
              setLoader(false);
  
              console.log(error, 'error----');
          }
      }
  
      useEffect(() => {
          fetchImages();
      }, []);

  return (
    <>
    <section className={classes.section_categories_page}>
      <div className={classes.container}>
        <h1 className={classes.section_categories_title}>
          Providing Good Qualities For Your Loving Kids
        </h1>

        <div className={classes.section_categories_grid}>

          
          <div
            className={classes.category_item}
            onClick={() => navigate("/category/rhymes")}
          >
            <div className={classes.category_item_image}>
              <img
                src="/assets/images/rhymes.png"
                alt="rhyme"
                className={classes.category_image}
              />
            </div>
            <h1 className={classes.category_item_heading}>Kids Rhymes</h1>
            <p className={classes.category_item_description}>
              Kids rhymes are fun and educational songs that help young children learn language, rhythm,
              through catchy tunes and playful lyrics.
            </p>
            <div className={classes.category_button_container}>
              <button
                type="button"
                className={classes.category_button}
                onClick={() => navigate("/category/rhymes")}
              >
                Watch Now
              </button>
            </div>
          </div>

          
          <div
            className={classes.category_item}
            onClick={() => navigate("/category/learning")}
          >
            <div className={classes.category_item_image}>
              <img
                src="/assets/images/book.png"
                alt="learning"
                className={classes.category_image}
              />
            </div>
            <h1 className={classes.category_item_heading}>Kids Learning</h1>
            <p className={classes.category_item_description}>
              Kids learning is all about helping children grow through fun, play, and simple lessons that
              build language, thinking, and social skills.
            </p>
            <div className={classes.category_button_container}>
              <button
                type="button"
                className={classes.category_button}
                onClick={() => navigate("/category/learning")}
              >
                Watch Now
              </button>
            </div>
          </div>

          
          <div
            className={classes.category_item}
            onClick={() => navigate("/category/stories")}
          >
            <div className={classes.category_item_image}>
              <img
                src="/assets/images/fairytale.png"
                alt="stories"
                className={classes.category_image}
              />
            </div>
            <h1 className={classes.category_item_heading}>Kids Stories</h1>
            <p className={classes.category_item_description}>
              Kids stories spark imagination and teach values through fun characters and adventures,
              helping children learn and grow in a joyful way.
            </p>
            <div className={classes.category_button_container}>
              <button
                type="button"
                className={classes.category_button}
                onClick={() => navigate("/category/stories")}
              >
                Watch Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </section>
                <section className={classes.section_product_page}>
                <div className={classes.container_product}>
                    <h1 className={classes.section_product_page_heading}>Special Care For Your Children</h1>

                    <div className={classes.section_product_page_grid}>
                        <div className={classes.section_product_page_grid_item}>
                            <p className={classes.section_product_page_grid_item_text1}>
                                Content Type
                            </p>
                            <p className={classes.section_product_page_grid_item_text2}>
                                3 Categories
                            </p>
                        </div>

                        <div className={classes.divider}>
                        </div>

                        <div className={classes.section_product_page_grid_item}>
                            <p className={classes.section_product_page_grid_item_text1}>
                                Browser Over
                            </p>
                            <p className={classes.section_product_page_grid_item_text2}>
                                150+ Videos
                            </p>
                        </div>
                    </div>

                    <h1 className={classes.section_product_page_heading2}>
                        Unlocking skills, One video at a time 🚀
                    </h1>

                    <p className={classes.section_product_page_paragraph}>
                        Unlock joyful learning with KidsLab: Videos that spark brilliance. Explore, Watch, Learn!
                    </p>
                </div>

                <img src="/assets/images/Book Illustration.png" alt="Book" className={classes.image_book_illustration} />
                <img src="/assets/images/World Illustration.png" alt="World" className={classes.image_world_illustration} />

                {loader ? <Loader on={loader} /> : (
                    <>
                        <div className={classes.section_carousel_marquee}>
                            <div className={classes.section_carousel_sub_container}>
                                {data.map((item, index) => {
                                    return (
                                        <div key={index} className={classes.section_carousel_item}>
                                            <img src={item?.image_link} alt="" className={classes.section_carousel_item_image} />
                                        </div>
                                    )
                                })}

                                {data.map((item, index) => {
                                    return (
                                        <div key={index} className={classes.section_carousel_item}>
                                            <img src={item?.image_link} alt="" className={classes.section_carousel_item_image} />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </>
                )}


            </section>

            <section className={classes.footer}>
                <div className={classes.container}>
                    <div className={classes.footer_container}>
                        <div className={classes.footer_logo_container}>
                            <img src="/assets/images/logo.png" alt="logo" className={classes.footer_logo} />
                        </div>

                        <div className={classes.copyright_container}>
                            <FaCopyright className={classes.copyright_icon} />
                            <p className={classes.copyright_text}>
                                Rainboo Softmate Pvt Ltd
                            </p>
                        </div>
                    </div>


                </div>
            </section> 
            
     <Drawer setDrawer={setDrawer} drawer={drawer} />

    </>
  );
};

export default CategoriesSection;
